module.exports = __webpack_public_path__ + "static/media/CM.2e8838ce.svg";